import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MultiChatComponent } from './multi-chat/multi-chat.component';
import { NavLayoutComponent } from '../../layouts/nav-layout/nav-layout.component';

const routes: Routes = [
  {
    path: '',
    component: NavLayoutComponent,
    children: [
      {
        path: '',
        component: MultiChatComponent,
        data: {
          title: 'Active tasks',
        },
      },
    ],
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChatRoutingModule {}
